import { defineComponent as f, ref as y, computed as n, openBlock as c, createElementBlock as m, normalizeClass as p, normalizeStyle as k, Fragment as g, renderList as b } from "vue";
import { pxToRem as a } from "@onereach/ui-components-common/utils";
import { _ as w } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const h = [
  // Position
  "relative",
  // Layout
  "overflow-hidden",
  // Box
  "p-0",
  // Borders
  "border-0",
  // Theme
  "bg-skeletons-gradient",
  "dark:bg-skeletons-gradient-dark",
  // Background
  "bg-repeat"
], q = [
  // Layout
  "flex",
  "flex-col",
  // Box
  "h-auto"
], x = [
  // Box
  "rounded-full"
], _ = [
  // Box
  "rounded-md"
], z = [
  // Box
  "w-full",
  "rounded-md"
], S = [
  // Background
  "bg-[length:200%]",
  // Animation
  "animate-skeleton-loader"
], O = f({
  name: "OrSkeletonCircle",
  props: {
    animated: {
      type: Boolean,
      required: !1,
      default: !0
    },
    size: {
      type: [Number, String],
      required: !1,
      default: 40
    }
  },
  expose: [
    "root"
  ],
  setup(e) {
    const l = y(), s = n(() => [
      "or-skeleton-v3",
      "or-skeleton-circle",
      ...h,
      ...x,
      ...e.animated ? S : []
    ]), i = n(() => {
      const o = e.size ?? 40, t = typeof o == "number" ? a(o) : o;
      return {
        width: t,
        "min-width": t,
        height: t,
        "min-height": t
      };
    });
    return {
      root: l,
      rootStyles: s,
      rootStyle: i
    };
  }
}), R = f({
  name: "OrSkeletonRect",
  props: {
    animated: {
      type: Boolean,
      required: !1,
      default: !0
    },
    width: {
      type: [Number, String],
      required: !1,
      default: "100%"
    },
    height: {
      type: [Number, String],
      required: !1,
      default: 36
    }
  },
  expose: [
    "root"
  ],
  setup(e) {
    const l = y(), s = n(() => [
      "or-skeleton-v3",
      "or-skeleton-rect",
      ...h,
      ..._,
      ...e.animated ? S : []
    ]), i = n(() => {
      const o = e.width ?? "100%", t = e.height ?? 36;
      return {
        width: typeof o == "number" ? a(o) : o,
        height: typeof t == "number" ? a(t) : t
      };
    });
    return {
      root: l,
      rootStyles: s,
      rootStyle: i
    };
  }
}), v = f({
  name: "OrSkeletonText",
  props: {
    animated: {
      type: Boolean,
      required: !1,
      default: !0
    },
    linesCount: {
      type: Number,
      required: !1,
      default: 1
    },
    width: {
      type: [Number, String],
      required: !1,
      default: "100%"
    },
    fontSize: {
      type: Number,
      required: !1,
      default: 16
    },
    lineHeight: {
      type: Number,
      required: !1,
      default: 24
    }
  },
  expose: [
    "root"
  ],
  setup(e) {
    const l = y(), s = n(() => [
      "or-skeleton-text-root",
      ...q
    ]), i = n(() => {
      const r = e.width ?? "100%";
      return {
        width: typeof r == "number" ? a(r) : r
      };
    }), o = n(() => [
      "or-skeleton-v3",
      "or-skeleton-text",
      ...h,
      ...z,
      ...e.animated ? S : []
    ]), t = n(() => {
      const r = e.fontSize ?? 16, d = ((e.lineHeight ?? 24) - r) / 2;
      return {
        height: typeof r == "number" ? a(r) : r,
        margin: `${typeof d == "number" ? a(d) : d} 0`
      };
    }), u = n(() => [...Array(e.linesCount).keys()]);
    return {
      root: l,
      containerStyles: s,
      containerStyle: i,
      rowStyles: o,
      rowStyle: t,
      lineKeys: u
    };
  }
});
function C(e, l, s, i, o, t) {
  return c(), m("div", {
    ref: "root",
    class: p(e.containerStyles),
    style: k(e.containerStyle)
  }, [
    (c(!0), m(g, null, b(e.lineKeys, (u) => (c(), m("div", {
      key: u,
      class: p(e.rowStyles),
      style: k(e.rowStyle)
    }, null, 6))), 128))
  ], 6);
}
const T = /* @__PURE__ */ w(v, [["render", C]]);
export {
  T as O,
  O as _,
  R as a
};
//# sourceMappingURL=OrSkeletonText-WYaAaljl.mjs.map
